import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import DeleteButton from 'Components/UI/DeleteButton';

const deleteAction = {
  columnName: 'Delete',
  component: DeleteButton,
  onSubmit: async (resource, onSuccess, onFailure) => {
    try {
      await resource.link('self').Delete();
      displaySuccess('Delete successful');
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      displayErrorMessage(err, err.errors);
      if (onFailure) {
        onFailure();
      }
    }
  },
};

export default deleteAction;
